import { render, staticRenderFns } from "./BagModal.vue?vue&type=template&id=1b363938&scoped=true"
import script from "./BagModal.vue?vue&type=script&lang=js"
export * from "./BagModal.vue?vue&type=script&lang=js"
import style0 from "./BagModal.vue?vue&type=style&index=0&id=1b363938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b363938",
  null
  
)

export default component.exports